
import {of as observableOf } from 'rxjs';
/**
 * Created by alex on 07/12/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { ActivatedRouteSnapshot } from "@angular/router";
import * as fromAuth from "../reducers";
import { LogoutAction } from "../actions/authentication";


@Injectable()
export class LogOutUserGuard  {
  constructor(
    private store: Store<fromAuth.AppState>
  ) { }

  signOut() {
      // todo: seems hacky, maybe do this in a view
      this.store.dispatch(new LogoutAction(true));
      return observableOf(false);
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.signOut();
  }
}
